import classNames from 'classnames'
import CustomSelect from '../../core/customSelect'

const VoiceSettingsRow = ({
    languageValue,
    voiceValue,
    languageOptions,
    voiceOptions,
    languageError,
    voiceError,
    formFieldText,
    onLanguageChange,
    onVoiceChange,
    isSidebarActive,
    isDisabled
}) => (
    <div className={classNames('voice-settings-row', {
        'wrapped': isSidebarActive
    })}>
        <CustomSelect
            name={formFieldText.language.key}
            value={languageValue}
            className="language"
            options={languageOptions}
            onChange={onLanguageChange}
            placeholder={formFieldText.language.placeholder}
            error={languageError}
            isDisabled={isDisabled}
        />

        <CustomSelect
            name={formFieldText.voice.key}
            value={voiceValue}
            options={voiceOptions}
            onChange={onVoiceChange}
            placeholder={formFieldText.voice.placeholder}
            infoText={formFieldText.voice.info}
            error={voiceError}
            isDisabled={isDisabled}
        />
    </div>
)

export default VoiceSettingsRow
